import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import css from "classnames"
import withTheme from "@mui/styles/withTheme"
import { ReactSVG } from "react-svg"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { withAuthentication } from "hoc-lib/appAuthentication"
import { getWindow } from "utils-lib/getWindow"
import redAlertsBadge from "./img/red-alerts-badge.svg"
import { ButtonTextIcon } from "../../../../../Base"
import "./TopMenuItem.scss"

export const menuItems = {
  PAY_MY_BILL: `paymybill`,
  CART: `cart`,
  DROP_OFF_LOCATIONS: `dropofflocations`,
  MY_WM: `mywm`,
  NOTIFICATIONS: `alerts`,
}

const TopMenuItem = ({
  getCartDetails,
  isSingleAccount,
  utilityType,
  utilityLabel,
  utilityLink = ``,
  analytics_key = ``,
  ecommerceCart = {},
  incidents,
  notifications,
  isLoggedIn,
  customerSelections,
  onlineProducts,
  language,
  hasMasterBillType,
}) => {
  const ssrWindow = getWindow()

  const renderButton = () => {
    const cartCount = get(ecommerceCart, `count`, ``)
    const products = get(onlineProducts, `onlineEcommercePricing.products`, [])
    const categoryId = encodeURI(
      !isEmpty(products[0])
        ? products[0]?.category_id || ``
        : get(customerSelections, `selectedCatalogs[0].id`, ``),
    )

    if (
      utilityType === menuItems.CART &&
      (get(ecommerceCart, `count`, ``) === `` || !categoryId)
    ) {
      return null
    }

    const classNames = css(
      `${utilityType}-top wm-link-light-green maax-font-weight-regular has-focus`,
      {
        "pt-1 cart-size": utilityLabel === `Cart`,
      },
    )

    const style = {
      padding: 0,
    }

    let finalUrl = utilityLink
    let hideLinkForMasterBillType = false

    const languageRoute = getLanguageRoute(language)

    if (utilityLink !== ``) {
      if (utilityType === menuItems.PAY_MY_BILL) {
        if (isLoggedIn && isSingleAccount) {
          finalUrl = `${languageRoute}/mywm/user/my-payment/billing/details`
        } else if (isLoggedIn) {
          finalUrl = `${languageRoute}/mywm/user/my-payment/billing/overview`
        } else {
          finalUrl = `${languageRoute}/mywm/my-payment/verify?redirect=${languageRoute}/mywm/user/my-payment/billing`
        }
      }
    }
    if (utilityLabel === `Pay My Bill` && hasMasterBillType) {
      hideLinkForMasterBillType = true
    }

    return (
      <>
        {!hideLinkForMasterBillType && (
          <ButtonTextIcon
            href={finalUrl}
            isLink={utilityType !== menuItems.CART}
            analytics_key={analytics_key}
            className={`${classNames} d-flex justify-content-center align-items-center`}
            aria-haspopup="false"
            style={{
              ...style,
              height: `45px`,
            }}
            testid="TopMenuItemButtonTextIcon"
            onClick={() => {
              if (utilityType === menuItems.CART) {
                getCartDetails().then((url) => {
                  if (url) {
                    ssrWindow.location = url
                  }
                })
              }
            }}
          >
            {utilityLabel}

            {utilityType === menuItems.CART && (
              <div className="counter" data-testid="TopMenuItemCartCount">
                {cartCount}
              </div>
            )}
            {utilityType === menuItems.NOTIFICATIONS &&
              (!isEmpty(notifications) || !isEmpty(incidents)) &&
              !customerSelections.alertsRead && (
                <ReactSVG
                  wrapper="span"
                  className="NotificationsBell__count position-absolute react-svg"
                  src={redAlertsBadge}
                />
              )}
          </ButtonTextIcon>
        )}
      </>
    )
  }

  if (
    utilityType === menuItems.CART &&
    get(ecommerceCart, `count`, ``) === ``
  ) {
    return null
  }
  return (
    <div
      data-testid="TopMenuItem"
      className="TopMenuItem d-flex h-100"
      style={{
        marginLeft: utilityType === menuItems.CART ? 15 : 24,
      }}
    >
      {renderButton()}
    </div>
  )
}

// // Note: React 19 no-longer supports propTypes. Leaving this for reference.
// TopMenuItemLegacy.propTypes = {
//   getCartDetails: PropTypes.func.isRequired,
//   isSingleAccount: PropTypes.bool.isRequired,
//   utilityType: PropTypes.string.isRequired,
//   utilityLabel: PropTypes.string.isRequired,
//   utilityLink: PropTypes.string,
//   analytics_key: PropTypes.string,
//   ecommerceCart: PropTypes.object,
//   incidents: PropTypes.array.isRequired,
//   notifications: PropTypes.array.isRequired,
//   /* From withAuthentication */
//   isLoggedIn: PropTypes.bool.isRequired,
//   customerSelections: PropTypes.object.isRequired,
//   onlineProducts: PropTypes.object.isRequired,
//   /* From withLocalization */
//   language: PropTypes.string.isRequired,
//   hasMasterBillType: PropTypes.bool.isRequired,
// }

// // Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// TopMenuItemLegacy.defaultProps = {
//   utilityLink: ``,
//   analytics_key: ``,
//   ecommerceCart: {},
// }

export default withTheme(withAuthentication(TopMenuItem))
